import _ from 'lodash';

export default formatGmaddressFields;

/**
 * @name formatGmaddressFields
 * @description Formats a Google Maps object into the fields we want to save in
 * the API
 * @param {object} gmaddress The type of object activity to format
 * @return {object} Returns the address fields
 */
function formatGmaddressFields(gmaddress) {
  return new Promise(function(resolve, reject) {
    let addressFields = {};

    // Find specific components in the Google address components array
    let addressComponents = _.map(gmaddress);

    // Street number
    if (_.some(addressComponents, {types: ['street_number']})) {
      let streetNumber = _.find(addressComponents, {
        types: ['street_number']
      });
      addressFields.street_number = streetNumber.long_name;
    }

    // Street address
    if (_.some(addressComponents, {types: ['street_address']})) {
      let streetAddress = _.find(addressComponents, {
        types: ['street_address']
      });
      addressFields.street_address = streetAddress.long_name;
    } else if (_.some(addressComponents, {types: ['route']})) {
      let route = _.find(addressComponents, {
        types: ['route']
      });
      addressFields.street_address = route.long_name;
    }

    // Locality
    if (_.some(addressComponents, {types: ['locality']})) {
      let locality = _.find(addressComponents, {
        types: ['locality']
      });
      addressFields.locality = locality.long_name;
    }

    // Postal code
    if (_.some(addressComponents, {types: ['postal_code']})) {
      let postalCode = _.find(addressComponents, {
        types: ['postal_code']
      });
      addressFields.postal_code = postalCode.long_name;
    }

    // Postal code
    if (_.some(addressComponents, {types: ['administrative_area_level_1']})) {
      let state = _.find(addressComponents, {
        types: ['administrative_area_level_1']
      });
      addressFields.state = state.long_name;
    }

    // Country
    if (_.some(addressComponents, {types: ['country']})) {
      let country = _.find(addressComponents, {
        types: ['country']
      });
      addressFields.country = country.short_name;
    }

    // Subpremise
    if (_.some(addressComponents, {types: ['subpremise']})) {
      let subpremise = _.find(addressComponents, {
        types: ['subpremise']
      });
      addressFields.subpremise = subpremise.long_name;
    }
    resolve(addressFields);
  });
}



// WEBPACK FOOTER //
// ./utils/format-gmaddress-fields.js